import gate from "../../../gate/gate";
import { IInstructorDetailInput } from "@features/instructor/types";
import client from "../../../gate/http-clients/api";

const InstructorApi = {
  instructorDetail: (slug: string, params?: { recache?: 0 | 1 }) =>
    gate.get<IInstructorDetailInput, never, { recache?: 0 | 1 }>({
      client,
      url: `/instructor/${slug}`,
      params,
    }),
};

export default InstructorApi;
